import {API} from "./_PSO";

document.addEventListener('fcm-token-change', e => {
    if (e.detail.oldToken !== e.detail.newToken) {
        API.asyncPostCall('change-fcm-token', e.detail);
    }
})
